const talks = [
    {
        year: 2024,
        title: 'From Hand-Crafted to AI-Driven: The Transformation of Software Engineering',
        event: 'Science Academy Artificial Intelligence Summer School',
        date: 'July 1-4, 2024',
        location: 'Ankara, Turkey'
    },
    {
        year: 2024,
        title: 'Process Smells in Software Engineering',
        event: 'Invited PhD Training Course Lecturer, University of Oulu',
        date: 'June 11-13, 2024',
        location: 'Oulu, Finland'
    },
    {
        year: 2023,
        title: 'Advancement on Empirical Research Methods',
        event: '17th ACM/IEEE International Symposium on Empirical Software Engineering and Measurement',
        date: 'October 27, 2023',
        location: 'New Orleans, USA'
    },
    {
        year: 2023,
        title: 'Detecting Process Smells A Deep Dive into Improving Efficiency in Software Development Workflow',
        event: 'Invited Speaker, LERO Science Foundation Ireland Research Center for Software',
        date: 'November 29, 2023',
        location: 'Online'
    },
    {
        year: 2023,
        title: 'Detecting Process Smells A Deep Dive into Improving Efficiency in Software Development Workflow',
        event: 'Guest Lecturer, University of Oulu',
        date: 'June 12, 2023',
        location: 'Oulu, Finland'
    },
    {
        year: 2023,
        title: 'Detecting Process Smells via Smellyzer',
        event: 'Guest Lecturer, JetBrains',
        date: 'May 04, 2023',
        location: 'Online'
    },
    {
        year: 2022,
        title: 'Towards a Taxonomy of Code Review Smells',
        event: 'Information and Software Technology Journal – Waste and Value in Software Engineering Live Event',
        date: 'April 05, 2022',
        location: 'Online'
    },
    {
        year: 2022,
        title: 'Best Practices in Bug Workflow Management',
        event: 'Invited Speaker, Arçelik Global',
        date: 'December 01, 2022',
        location: 'Online'
    },
    {
        year: 2022,
        title: 'Yazılım Mühendisliğinde AI Tabanlı Yaklaşımlar',
        event: 'Invited Speaker, Tatil Sepeti',
        date: 'October 22, 2022',
        location: 'Online'
    },
    {
        year: 2022,
        title: 'Data Science in Software Engineering',
        event: 'Invited Speaker, IDEA Teknoloji',
        date: 'June 07, 2022',
        location: 'Online'
    },
    {
        year: 2022,
        title: 'Data Science in Software Engineering',
        event: 'Invited Speaker, KuveytTurk',
        date: 'April 28, 2022',
        location: 'Online'
    },
    {
        year: 2021,
        title: 'Code Reviewer Recommendation using Artifact Traceability Graphs',
        event: 'Invited Speaker, METU Multimedia Informatics Department',
        date: 'April 14, 2021',
        location: 'METU Multimedia Informatics Department'
    },
    {
        year: 2021,
        title: 'Developing Your Most Important Product',
        event: 'Bilkent University CV Workshop',
        date: 'February 09, 2021',
        location: 'Online'
    },
    {
        year: 2020,
        title: 'Software Development Productivity',
        event: 'Invited Speaker, ATA Teknoloji Platformları (ATP)',
        date: 'August 09, 2020',
        location: 'Online'
    },
    {
        year: 2020,
        title: 'How to develop software?',
        event: 'Bilkent Youth Academy (Gençlik Akademisi)',
        date: 'July 13-23, 2020',
        location: 'Online)'
    },
    {
        year: 2019,
        title: 'Investigating the Validity of Ground Truth in Empirical Software Engineering',
        event: 'International Software Engineering Research Network 2019',
        location: 'Porto de Galinhas, Brazil',
        date: 'September 17, 2019'
    },
    {
        year: 2019,
        title: 'Serious Games and Gamification in Software Engineering',
        event: 'Games and Politics, Cer Modern',
        location: 'Ankara, Turkey',
        date: 'May 04, 2019'
    },
    {
        year: 2019,
        title: 'Yazılım Yaşam Döngüsü Modelleri ve Kurumlar için Yazılım Test ve Kalitenin Önemi',
        event: 'Havelsan Teknoloji Sohbetleri',
        location: 'Ankara, Turkey',
        date: 'Jan 22, 2019'
    },
    {
        year: 2018,
        title: 'Empirical Software Engineering – Increasing Software Productivity',
        event: 'Hacettepe University',
        location: 'Ankara, Turkey',
        date: 'Dec 19, 2018'
    },
    {
        year: 2018,
        title: 'Usage of Gamification in Software Engineering',
        event: 'Çankaya University',
        location: 'Ankara, Turkey',
        date: 'May 5, 2018'
    },
    {
        year: 2018,
        title: '13 ways to increase Software Development Productivity',
        event: 'Guest Speaker, ASELSAN',
        location: 'Ankara, Turkey',
        date: 'March 23, 2018'
    },
    {
        year: 2016,
        title: 'How to Boost your Software Development Productivity',
        event: 'Agile Turkey Summit 2016, Wyndham Grand Levent',
        location: 'Istanbul, Turkey',
        date: 'Oct 6, 2016'
    },
    {
        year: 2015,
        title: 'The Roles and Their Interactions in Software Industry',
        event: 'Industry Panel, Bilkent University',
        location: 'Ankara, Turkey',
        date: 'Nov 4, 2015'
    },
    {
        year: 2015,
        title: 'Integrated Application Lifecycle Management Transformation in HAVELSAN',
        event: 'Agile Turkey Summit 2015, Grand Cevahir Convention Center',
        location: 'Istanbul, Turkey',
        date: 'Oct 9, 2015'
    },
    {
        year: 2015,
        title: 'Adopting Application Lifecycle Management Principles',
        event: 'Invited Speaker, Çankaya University',
        location: 'Ankara, Turkey',
        date: 'Oct 6, 2015'
    },
    {
        year: 2015,
        title: 'Experiences Adopting ALM in a Hybrid Organization',
        event: 'ALM Forum 2015 Bell Harbor Conference Center',
        location: 'Seattle, USA',
        date: 'May 19, 2015'
    },
    {
        year: 2012,
        title: 'R&D Innovation Policy and Practices',
        event: 'Industry R&D Centers Symposium',
        date: 'April 10, 2012',
        location: 'Adana, Turkey'
    },
    {
        year: 2020,
        title: 'How to boost software development productivity?',
        event: 'Invited Speaker, Havelsan',
        date: 'November 27, 2020',
        location: 'Ankara, Turkey'
    },
];

export default talks;
